import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinambatturchennai() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Ambattur Chennai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Ambattur Chennai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Ambattur Chennai, catering to the transportation needs of IT parks, industrial units, and corporate offices in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Ambattur Chennai.',

    top: 'Top Places to Visit in Chennai with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s most famous landmark and one of the longest urban beaches in the world, stretching over 13 km along the Bay of Bengal. The beach is popular for morning jogs, evening strolls, kite flying, and street food like sundal, murukku, and fresh coconut water. It also hosts cultural events, festivals, and local gatherings, making it a hub of leisure, social activity, and city life."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a classic example of Dravidian architecture, dedicated to Lord Shiva. Known for its vibrant gopuram, intricate carvings, and peaceful inner sanctum, the temple attracts devotees and tourists alike. The temple’s lively festivals, daily rituals, and traditional music and dance events offer a deep insight into Chennai’s spiritual and cultural heritage."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, established in 1644 by the British East India Company, is a historic landmark and administrative center in Chennai. It houses St. Mary’s Church, the Tamil Nadu Legislative Assembly, and a museum displaying colonial artifacts. Visitors can explore the fort’s ramparts, bastions, and exhibits, experiencing Chennai’s colonial history and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica, a majestic Gothic-style church, is built over the tomb of St. Thomas, one of Jesus Christ’s apostles. With beautiful stained-glass windows, elegant interiors, and serene surroundings, it attracts pilgrims and tourists alike. The church is both a spiritual center and a significant historical landmark, reflecting the Christian heritage of Chennai."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park, located within Chennai city limits, is one of India’s smallest national parks. It is home to deer, blackbucks, exotic birds, and reptiles, and also features a Snake Park and Children’s Park. The park offers walking trails, picnic areas, and peaceful green spaces, making it ideal for families, wildlife enthusiasts, and students looking for nature amidst the urban environment."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the famous Tamil poet and philosopher Thiruvalluvar. Its grand chariot-shaped auditorium and intricate stone carvings depict his literary works. The site serves as a cultural landmark and a center for literary and artistic appreciation, drawing visitors interested in Tamil culture, history, and architecture."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a serene coastal spot known for its clean sands, calm waters, and beautiful sunsets. Unlike Marina Beach, it is quieter and less crowded, making it ideal for evening walks, family outings, and leisure activities. Local cafés and eateries nearby add to the beach’s charm, offering a relaxing seaside experience."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus with lush gardens, century-old trees, and historical buildings. It is a center for spiritual study, meditation, and philosophical discussions. Visitors can enjoy serene walks, birdwatching, and the famous Adyar Banyan Tree, experiencing a calm and reflective environment within the bustling city."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "Chennai Rail Museum highlights the evolution of Indian railways, featuring vintage locomotives, carriages, photographs, and interactive exhibits. The museum offers miniature train rides, making it educational and entertaining for families, students, and railway enthusiasts. Visitors gain insight into India’s railway heritage while enjoying hands-on learning experiences."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a botanical garden in central Chennai, featuring themed gardens, walking paths, landscaped lawns, and exotic plant species. It is perfect for morning walks, photography, and peaceful relaxation. The garden provides a refreshing green retreat amidst Chennai’s busy urban environment, ideal for families, nature lovers, and tourists."
  }
],


"services": [
{
"name": "Ambattur Industrial Cab",
"description": "Ambattur Industrial Cab provides reliable and structured transportation solutions for employees and industrial workers commuting to factories and industrial zones in Ambattur. The service includes well-maintained vehicles, GPS tracking, trained drivers, and multi-shift support, ensuring safe, timely, and efficient travel for daily workforce operations."
},
{
"name": "Ambattur Staff Transportation",
"description": "Ambattur Staff Transportation delivers comprehensive mobility solutions for corporate offices, IT parks, and industrial facilities in Ambattur. The service offers scheduled pickup and drop, route optimization, professional drivers, and real-time tracking to guarantee punctual and secure employee commutes across shifts."
},
{
"name": "Corporate Shuttle Ambattur",
"description": "Corporate Shuttle Ambattur provides high-capacity shuttle services for bulk staff movement using AC minibuses and vans. The service features optimized routing, automated attendance integration, GPS-enabled monitoring, and strict safety protocols, making it ideal for companies with large employee bases."
},
{
"name": "Employee Pickup Drop Ambattur",
"description": "Employee Pickup Drop Ambattur offers structured daily commute services for employees traveling to offices, factories, and industrial zones. With fixed and flexible routes, professional chauffeurs, and GPS-enabled vehicles, the service ensures reliable, safe, and timely transportation for all staff categories."
},
{
"name": "Business Cab Ambattur",
"description": "Business Cab Ambattur provides professional corporate travel solutions for executive meetings, client visits, airport transfers, and inter-office travel. The service features premium vehicles, trained drivers, real-time tracking, and prompt dispatch, ensuring a comfortable and reliable travel experience."
},
{
"name": "Company Transport Ambattur",
"description": "Company Transport Ambattur specializes in end-to-end corporate transportation services, including employee travel, executive commute, and bulk staff mobility. The service offers managed fleet operations, route planning, vehicle maintenance, trained drivers, and GPS tracking for seamless corporate mobility."
},
{
"name": "Monthly Cab Ambattur",
"description": "Monthly Cab Ambattur provides long-term cab rental solutions for businesses needing consistent employee transportation. With dedicated vehicles, driver management, flexible monthly plans, and GPS monitoring, the service ensures uninterrupted, cost-effective, and efficient workforce commute operations."
},
{
"name": "Best Corporate Cab Ambattur",
"description": "Best Corporate Cab Ambattur delivers premium corporate transportation with high-quality vehicles, verified drivers, strict safety standards, and exceptional service. Ideal for executives, managers, and business visitors, it guarantees smooth, comfortable, and punctual travel across Ambattur."
},
{
"name": "Affordable Cab Ambattur",
"description": "Affordable Cab Ambattur offers cost-effective employee and corporate travel solutions without compromising on safety, comfort, or reliability. The service is designed for startups, SMEs, and mid-sized companies, featuring trained drivers, clean vehicles, and optimized routes for daily commute needs."
},
{
"name": "Outstation Cab Ambattur",
"description": "Outstation Cab Ambattur provides long-distance corporate travel for client visits, factory inspections, business trips, and executive travel. Equipped with comfortable sedans and SUVs, professional chauffeurs, and GPS tracking, the service ensures safe and timely intercity transportation for corporate staff."
},
{
"name": "Sedan Cab Ambattur",
"description": "Sedan Cab Ambattur offers premium sedans for executive and managerial travel, airport transfers, client meetings, and daily office commute. Vehicles are well-maintained, comfortable, and operated by trained drivers to provide a reliable and refined corporate travel experience."
},
{
"name": "SUV Cab Ambattur",
"description": "SUV Cab Ambattur delivers spacious and high-comfort SUVs suitable for team travel, industrial visits, senior executive transport, and long-distance corporate trips. With GPS-enabled tracking, professional drivers, and regular maintenance, it ensures a premium mobility experience."
},
{
"name": "Factory Worker Transport Ambattur",
"description": "Factory Worker Transport Ambattur provides large-scale worker transportation solutions for factories and industrial units. The service includes multi-shift support, structured routes, safety protocols, trained drivers, and real-time vehicle tracking to guarantee reliable and safe daily commutes."
},
{
"name": "Corporate Fleet Ambattur",
"description": "Corporate Fleet Ambattur offers end-to-end fleet management services for businesses, including sedans, SUVs, and employee shuttles. The service features driver management, vehicle maintenance, GPS-enabled tracking, and scalable fleet availability to support corporate and industrial transport requirements in Ambattur."
},
{
"name": "Staff Mobility Ambattur",
"description": "Staff Mobility Ambattur delivers comprehensive workforce transport management, integrating employee commute planning, shuttle services, fleet coordination, GPS tracking, and multi-shift operations. It ensures efficient, safe, and reliable daily staff mobility for companies in Ambattur."
}
],

"tableData": [
["Ambattur Industrial Cab", "Ambattur Staff Transportation"],
["Corporate Shuttle Ambattur", "Employee Pickup Drop Ambattur"],
["Business Cab Ambattur", "Company Transport Ambattur"],
["Monthly Cab Ambattur", "Best Corporate Cab Ambattur"],
["Affordable Cab Ambattur", "Outstation Cab Ambattur"],
["Sedan Cab Ambattur", "SUV Cab Ambattur"],
["Factory Worker Transport Ambattur", "Corporate Fleet Ambattur"],
["Staff Mobility Ambattur", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Ambattur Chennai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Ambattur, Chennai, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Ambattur’s industrial areas, corporate offices, and business hubs, helping professionals reach their destinations on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Ambattur Chennai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]




































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Ambattur, Chennai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and employees in Ambattur, Chennai.',
  },
  {
    question: 'What types of corporate cab services are available in Ambattur?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and dedicated fleet solutions for corporate offices.',
  },
  {
    question: 'Do you support daily commute services for employees in Ambattur?',
    answer: 'Yes, we offer structured daily commute services with timely pickups, optimized routes, and multi-shift transportation for employees in Ambattur.',
  },
  {
    question: 'How can companies book corporate cab services in Ambattur?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 corporate travel support team.',
  },
  {
    question: 'Which vehicle options are available for corporate travel in Ambattur?',
    answer: 'We provide hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on company requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Ambattur?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts tailored for corporate offices in Ambattur.',
  },
  {
    question: 'Are your cabs equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift employee transportation in Ambattur?',
    answer: 'Yes, we manage transportation for early morning, night, weekend, and rotational shifts for employees in Ambattur.',
  },
  {
    question: 'What payment options are available for corporate cab services in Ambattur?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Iyer',
    feedback: 'Excellent corporate cab service in Ambattur. Punctual pickups and professional drivers make daily commuting hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Divya Natarajan',
    feedback: 'Reliable and efficient employee transportation for our Ambattur office. Vehicles are clean and well-maintained.',
    rating: 5,
  },
];






































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Ambattur Chennai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-ambattur.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in Ambattur Chennai, including industrial employee transport, corporate shuttles, staff pickup & drop, business cabs, monthly cab plans, outstation trips, and corporate fleet solutions for companies operating in Ambattur.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-ambattur-chennai"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Ambattur Chennai | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Ambattur Chennai including industrial employee transport, corporate shuttles, staff pickup & drop, business cabs, monthly cab plans, outstation trips, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Ambattur Industrial Cab, Ambattur Staff Transportation, Corporate Shuttle Ambattur, Employee Pickup Drop Ambattur, Business Cab Ambattur, Company Transport Ambattur, Monthly Cab Ambattur, Best Corporate Cab Ambattur, Affordable Cab Ambattur, Outstation Cab Ambattur, Sedan Cab Ambattur, SUV Cab Ambattur, Factory Worker Transport Ambattur, Corporate Fleet Ambattur, Staff Mobility Ambattur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinambatturchennai;